import React from 'react';
import { MapPin, Phone, MessageCircle, ArrowUpRight } from 'lucide-react';
import { companyInfo } from '../data/mock';

const ContactSection = () => {
  return (
    <section id="contact" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-gold-600 font-semibold text-sm tracking-widest uppercase mb-4">
            Contato
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-navy-900 mb-6">
            Vamos <span className="text-gold-600">conversar</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Estamos prontos para entender seu negócio e criar soluções sob medida
          </p>
          <div className="w-24 h-1 bg-gold-500 mx-auto mt-6" />
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Contact Info */}
          <div className="space-y-8">
            <div className="flex items-start gap-6 group">
              <div className="w-16 h-16 bg-navy-900 group-hover:bg-gold-500 rounded-2xl flex items-center justify-center flex-shrink-0 transition-all duration-500">
                <MessageCircle className="w-8 h-8 text-gold-500 group-hover:text-navy-900 transition-colors duration-500" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-navy-900 mb-2">WhatsApp</h3>
                <p className="text-gray-600 mb-3">Resposta rápida pelo WhatsApp</p>
                <a 
                  href={`https://wa.me/${companyInfo.contact.whatsapp}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-gold-600 font-semibold hover:text-navy-900 transition-colors duration-300"
                >
                  {companyInfo.contact.phone}
                  <ArrowUpRight size={16} />
                </a>
              </div>
            </div>

            <div className="flex items-start gap-6 group">
              <div className="w-16 h-16 bg-navy-900 group-hover:bg-gold-500 rounded-2xl flex items-center justify-center flex-shrink-0 transition-all duration-500">
                <Phone className="w-8 h-8 text-gold-500 group-hover:text-navy-900 transition-colors duration-500" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-navy-900 mb-2">Telefone</h3>
                <p className="text-gray-600 mb-3">Ligue para conversar</p>
                <a 
                  href={`tel:+${companyInfo.contact.whatsapp}`}
                  className="inline-flex items-center gap-2 text-gold-600 font-semibold hover:text-navy-900 transition-colors duration-300"
                >
                  {companyInfo.contact.phone}
                  <ArrowUpRight size={16} />
                </a>
              </div>
            </div>

            <div className="flex items-start gap-6 group">
              <div className="w-16 h-16 bg-navy-900 group-hover:bg-gold-500 rounded-2xl flex items-center justify-center flex-shrink-0 transition-all duration-500">
                <MapPin className="w-8 h-8 text-gold-500 group-hover:text-navy-900 transition-colors duration-500" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-navy-900 mb-2">Localização</h3>
                <p className="text-gray-600 mb-3">Nosso ponto de operação</p>
                <p className="text-gold-600 font-semibold">
                  {companyInfo.contact.location}
                </p>
              </div>
            </div>
          </div>

          {/* CTA Card */}
          <div className="bg-navy-900 rounded-3xl p-8 lg:p-12 relative overflow-hidden">
            {/* Decorative */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-gold-500/10 rounded-full blur-3xl" />
            
            <div className="relative">
              <img 
                src="https://customer-assets.emergentagent.com/job_dumangin-admin/artifacts/mfxuvisw_2e59b12d0_logosimboloGOODquality.png" 
                alt="DumanginADM" 
                className="w-20 h-20 object-contain mb-8"
              />

              <h3 className="text-2xl lg:text-3xl font-bold text-white mb-4">
                Pronto para transformar seu negócio?
              </h3>

              <p className="text-white/70 text-lg leading-relaxed mb-8">
                Entre em contato agora e descubra como podemos ajudar sua empresa a crescer de forma estruturada e estratégica.
              </p>

              <a
                href={`https://wa.me/${companyInfo.contact.whatsapp}?text=Olá! Vim pelo site e gostaria de saber mais sobre os serviços da DumanginADM.`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 bg-gold-500 hover:bg-gold-600 text-navy-900 px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 hover:shadow-xl hover:shadow-gold-500/25"
              >
                <MessageCircle size={24} />
                Falar com {companyInfo.contact.name.split(' ')[0]}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
